import TBLOGO from "../../../assets/TB-LoGO.webp";

const footerServices = [
  { label: 'IT Hardware', href: '#services' },
  { label: 'Networking', href: '#services' },
  { label: 'Laptop & Desktop', href: '#services' },
  { label: 'Printers & Xerox', href: '#services' },
  { label: 'AMC & IT Support', href: '#amc' },
];

const LOGO_URL = TBLOGO;

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#00164A' }}>
      <div className="max-w-site mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          <div>
            {/* Logo in white/light container so it's visible on dark navy */}
            <div className="inline-block bg-white rounded-xl px-4 py-2.5 mb-5">
              <img
                src={LOGO_URL}
                alt="TechBridge Systems & Solutions"
                className="h-10 md:h-12 w-auto object-contain"
                draggable="false"
              />
            </div>
            <p className="text-sm text-background-200/70 leading-relaxed max-w-[260px]">
              One Stop. Total IT Solution.
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.15em] text-background-200/50 mb-5">Services</h4>
            <ul className="space-y-3">
              {footerServices.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(s.href); }}
                    className="text-sm text-background-200/70 hover:text-background-50 transition-colors duration-200 inline-flex items-center gap-1 group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-primary-500 transition-all duration-300 mr-0 group-hover:mr-1"></span>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.15em] text-background-200/50 mb-5">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+919940148039" className="text-sm text-background-200/70 hover:text-background-50 transition-colors duration-200 inline-flex items-center gap-2">
                  <i className="ri-phone-line text-primary-500/70 text-xs"></i>
                  +91 99401 48039
                </a>
              </li>
              <li>
                <a href="mailto:techbridge32@gmail.com" className="text-sm text-background-200/70 hover:text-background-50 transition-colors duration-200 inline-flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500/70 text-xs"></i>
                  techbridge32@gmail.com
                </a>
              </li>
              <li>
                <p className="text-sm text-background-200/60 leading-relaxed inline-flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-500/70 text-xs mt-0.5"></i>
                  Ambattur, Chennai – 600058
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/40">
            © 2026 TechBridge Systems &amp; Solutions. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }} className="text-xs text-background-200/40 hover:text-background-200/70 transition-colors cursor-pointer">
              Back to top <i className="ri-arrow-up-line ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}